export const GIT_BRANCH: string = "master";
export const GIT_VERSION: string = "906fb2e97";



// WEBPACK FOOTER //
// ./src/gitVersion.ts